export default "__VITE_ASSET__D0kTJXjb__"